import { gql } from '@apollo/client';

// Apollo creates cache id based on the object id, so some nodes may have id which is not being used
export const fetchTransactionAccount = gql`
  query fetchTransactionAccountV2($id: ID!) {
    transactionAccount(id: $id) {
      id
      partnerAccountId
      transactionAccountNumber
      billingAccountsList {
        status
        nodes {
          status
          transactionAccountNumber
        }
      }
      billToParty {
        id
        name
        addressLine1
        addressLine2
        city
        state
        country
        postcode
        taxId
        taxIds {
          id
          label
          taxExempt
          metadata {
            vatStatus
          }
        }
        taxLabels {
          region
          taxIdLabels {
            description
            displayName
            type
            metadata {
              type
              labels {
                default
                label
                vatStatus
              }
            }
          }
        }
        taxExempt
      }
      productSubscriptions {
        nodes {
          billingFrequency
          billingStatus
          entitlementNumber
          pricingPlanId
          pricingPlan {
            type
            billingFrequency
            id
            currency
            pricingPlanType
            status
            description
            tiers {
              unitAmount
              flatAmount
              floor
              ceiling
            }
          }
          transactionAccountNumber
          latestPeriodEndDate
          latestPeriodStartDate
          productName
          productId
          edition
          offeringId
          cloudSiteHostname
          billingGroupId
          provisioningStatus
          id
          billedUsers
          trial
          isSandbox
          isApp
          trialEndDate
        }
      }
      billToPartyPricingEligibilty
      availableShipToParties {
        nodes {
          id
          name
          addressLine1
          addressLine2
          city
          state
          country
          postcode
          taxId
          taxExempt
        }
      }
      billingAdmins {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          email
          atlassianAccountId
          fullName
          isEmailVerified
        }
      }
      displayName
      isPartner
      status
      availableInvoiceGroups {
        totalCount
        nodes {
          id
          name
          currency
          shipToParty {
            id
            name
            addressLine1
            addressLine2
            city
            state
            country
            postcode
            taxId
          }
          defaultPaymentMethod {
            id
            type
            paymentIssue
            ... on CreditCard {
              card {
                expirationMonth
                expirationYear
                last4Numbers
                brand
              }
            }
            ... on PaymentOnTerms {
              terms {
                invoiceDueDays
              }
            }
          }
          shipToPriceEligibility
        }
      }
      availablePaymentMethods {
        totalCount
        nodes {
          id
          type
          default
          paymentIssue
          ... on CreditCard {
            card {
              expirationMonth
              expirationYear
              last4Numbers
              brand
            }
          }
          ... on PaymentOnTerms {
            terms {
              invoiceDueDays
              payOnStatement
            }
            totalCreditLimit
            paymentMethod
          }
        }
      }
      updatePaymentMethodLink
      creditRequestAppLink
    }
  }
`;
